export const CREATE_SICK_LEAVE = "CREATE_SICK_LEAVE";
export const FETCH_SICK_LEAVES = "FETCH_SICK_LEAVES";
export const FETCH_SICK_LEAVE = "FETCH_SICK_LEAVE";
export const EDIT_SICK_LEAVE = "EDIT_SICK_LEAVE";
export const DELETE_SICK_LEAVE = "DELETE_SICK_LEAVE";
